<div class="term-container">
  <div class="term-nav-bar box">
    <div class="term-nav-bar-title">شرایط و قوانین</div>
    <div class="term-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="term-holder box">
    <p>
      ماده ۱. این سیاست&zwnj;نامه حفظ حریم خصوصی برای تمامی محصولات و خدمات
      ارائه شده توسط شرکت کاوشگران رادین فناور سلامت با نام تجاری کرفس شامل
      وب&zwnj;سایت، اپلیکیشن&zwnj;های کالری&zwnj;شمار کرفس، رژیم کرفس (یا بنتو)،
      و جیم می&zwnj;باشد. کرفس یک اپلیکیشن کالری&zwnj;شمار و رژیم کرفس یک
      اپلیکیشن برای رژیم&zwnj;های متنوع غذایی می&zwnj;باشد. جیم یک اپلیکیشن برای
      ارائه برنامه&zwnj;های تمرین و ورزش است. <br />
      این اپلیکیشن&zwnj;ها با هدف بهبود وضعیت تغذیه&zwnj;ای، برنامه ورزشی، کاهش،
      افزایش و به طور کلی ثبات وزن در جامعه توسعه یافته&zwnj;اند و به کاربران
      اجازه می&zwnj;دهند تا با ثبت&zwnj;نام در برنامه و وارد کردن مشخصات فردی
      خود و میزان فعالیت&zwnj;ها، در مسیر حرکت به سمت وزن ایده&zwnj;آل گام
      بردارند و با استفاده از روش کالری&zwnj;شماری&zwnj; (کالری&zwnj;شمار کرفس)
      به همراه ارائه دستورهای غذایی متنوع (رژیم کرفس یا بنتو) زندگی
      سالم&zwnj;تری را تجربه کنند. <br />
      ماده ۲. قبل از استفاده از اپلیکیشن&zwnj;ها کاربران ملزم به ثبت&zwnj;نام
      می&zwnj;باشند. ثبت نام در تمامی اپلیکیشن&zwnj;ها رایگان است. در قسمت
      ثبت&zwnj;نام بعضی مشخصات شخصی از قبیل نام و نام خانودگی، شماره تلفن، سن و
      وزن از کاربر پرسیده می&zwnj;شود. جمع&zwnj;آوری این اطلاعات به کرفس اجازه
      می&zwnj;دهد تا دید دقیق&zwnj;تری نسبت به کاربران خود داشته باشد تا علاوه
      بر تعامل راحت&zwnj;تر، امکانات مناسب&zwnj;تری را برای&zwnj; آن&zwnj;ها
      فراهم کند. کرفس این اطلاعات را بدون اجازه&zwnj;ی کاربر با هیچ شخص ثالثی در
      میان نخواهد گذاشت. <br />
      ماده ۳. کاربر، مسئول حفظ و نگهداری سخت&zwnj;افزار کامپیوتر، تلفن&zwnj;ها و
      سایر ابزار ضروری برای دسترسی و استفاده از این سایت و تمام هزینه&zwnj;های
      مرتبط به آن بوده و کرفس مسئول صدمات ناشی از ابزار کاربر نمی&zwnj;باشد.
      <br />
      ماده ۴. کرفس اقدامات امنیتی لازم و مناسبِ سخت&zwnj;افزاری و
      نرم&zwnj;افزاری را برای جلوگیری از دسترسی&zwnj;های غیرمجاز و افشاء یا
      تخریب اطلاعات شخصی کاربر انجام می&zwnj;دهد. کرفس اجازه دسترسی به اطلاعات
      شخصی کاربران را به کارکنان این شرکت می&zwnj;دهد اما این افراد با تعهدات
      محرمانه مواجه هستند و در صورت تخطی از این تعهدات با پیگرد قانونی مواجه
      خواهند شد. همچنین مطالعات آماری در مورد جامعه&zwnj;ی کاربران کرفس بدون
      استفاده از هویت&zwnj; شخصی آن&zwnj;ها و کاملاً ناشناس انجام می&zwnj;شود.
      <br />
      ماده ۵. کرفس ممکن است با شرکت&zwnj;ها، وبسایت&zwnj;ها یا اپلیکیشن&zwnj;های
      دیگر همکاری کند. اما کرفس هیچ&zwnj;گونه مسئولیتی در برابر سیاست&zwnj;های
      حفظ حریم شخصی و کاربری آنها ندارد. در صورتی که تمایل دارید از طریق
      اپلیکیشن&zwnj;های کرفس به سایت&zwnj;ها یا اپلیکیشن&zwnj;های دیگر وارد
      شوید، برای اطلاع از سیاست&zwnj;های حفظ حریم خصوصی این مجموعه&zwnj;ها به
      وب&zwnj;سایت آنها مراجعه کنید. <br />
      ماده ۶. کاربران کرفس می&zwnj;توانند با هر بار ورود به برنامه نسبت به تغییر
      و یا حذف اطلاعات شخصی خود مانند نام کاربری یا رمز عبور اقدام نمایند.
      <br />
      ماده ۷. تنها افراد بالای ۱۸ سال حق انجام معامله (خرید) در سایت کرفس را
      دارند. <br />
      ماده ۸. محصول&zwnj;های خریدنی در سایت و اپلیکیشن کرفس اشتراک&zwnj;های
      مدت&zwnj;دار در کرفس است که با خریداری آن&zwnj;ها کاربر به قسمت «هدف»،
      «نمودارها»، «ویدیوهای تمرین&zwnj;های خانگی» و همچنین قسمت «دستور پخت
      غذاهای رژیمی» دسترسی خواهد داشت. محصول&zwnj;های خریدنی در اپلیکیشن رژیم
      کرفس (بنتو) رژیم&zwnj;های ۲۸ روزه است که بعد از اتمام مدت آن غیرفعال
      می&zwnj;گردد. همچینین محصول&zwnj;های خریدنی در اپلیکیشن جیم اشتراک
      مدت&zwnj;دار است که با خرید آن امکان استفاده از برنامه&zwnj;های ورزشی و
      ساختن برنامه در دسترس خواهد شد. <br />
      ماده ۹. فرایند خرید در سایت کرفس به شرح زیر است: <br />
      ●&#9;انتخاب بسته&zwnj;ی اشتراکی مورد نظر <br />
      ●&#9;مشاهده&zwnj;ی پیش&zwnj;فاکتور <br />
      ●&#9;پرداخت از طریق درگاه اینترنتی <br />
      ●&#9;دریافت بسته&zwnj;ی اشتراکی <br />
      ماده ۱۰. اختلال در سرویس اینترنت یا هر دلیلی که باعث شود فرایند خرید به
      انجام نرسد باعث از بین رفتن حق کاربر نمي&zwnj;شود و در صورتی که مبلغی از
      حساب کاربر کسر شده باشد از طریق بانک به وی بازپرداخته خواهد شد. <br />
      ماده ۱۱. اطلاعات شخصی کاربران کرفس شامل نام، شماره&zwnj;ی تلفن و رمز عبور
      آنها نزد کرفس محفوظ است و کرفس آن را به شخص یا شرکت دیگری واگذار نخواهد
      کرد. <br />
      ماده ۱۲. حفاظت از رمز عبور به عهده&zwnj;ی کاربر است و کرفس مسئولیتی از
      قبال آن ندارد. کاربران می&zwnj;توانند برای بازیابی رمز عبور خود به قسمت
      «فراموشی رمز عبور» مراجعه کنند. <br />
      ماده ۱۳. کرفس بر مبنای قوانین جرايم رایانه&zwnj;ای متعهد می&zwnj;شود با
      استفاده از تمامی امکانات و منابع خود در جهت حفظ و حراست از اطلاعات شخصی
      کاربران اقدام نماید. بدیهی است که استفاده&zwnj;ی مداوم از برنامه به
      منزله&zwnj;ی تایید شرایط سیاست&zwnj;نامه&zwnj;ی حفظ حریم خصوصی کرفس
      می&zwnj;باشد. <br />
      ماده ۱۴. در صورت بارداری و شیردهی و همینطور داشتن بیماری قبل از استفاده از
      کالری&zwnj;شمار کرفس و رژیم کرفس، حتما با پزشک و متخصص تغذیه مشورت نمایید.
      <br />
      ماده ۱۵. در صورت داشتن هرگونه ابهام، سوالات خود را به یکی از روش&zwnj;های
      زیر با کرفس در میان بگذارید: <br />
      شماره پشتیبانی: 02191006901 <br />
      ایمیل کرفس:&zwnj; info@eynakgroup.com <br />
      آدرس: تهران، خیابان ولی&zwnj;عصر، نرسیده به میدان ونک، خیابان فوزی، خیابان
      شمس لاهیجانی، بن&zwnj;بست دوازدهم، پلاک ۸ <br />
      <br />
    </p>
  </div>
</div>
